import PropTypes from 'prop-types';

export default PropTypes.shape({
  segmentId: PropTypes.string,
  pin: PropTypes.string
});
